
import React from 'react';
import { motion } from 'framer-motion';

const Imprint = () => {
  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary-600 to-primary-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Imprint
            </h1>
            <p className="text-xl text-primary-100 max-w-3xl mx-auto">
              Legal information about Trbe UG (haftungsbeschränkt)
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white rounded-xl shadow-lg p-8"
          >
            <div className="prose max-w-none">
              <h2 className="text-2xl font-bold text-neutral-900 mb-6">Impressum</h2>
              
              <div className="space-y-6 text-neutral-700">
                <div>
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Company Information</h3>
                  <p>
                    <strong>Trbe UG (haftungsbeschränkt)</strong><br />
                    Rheinstr. 46<br />
                    12161 Berlin<br />
                    Germany
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Registration</h3>
                  <p>
                    <strong>Handelsregister:</strong> HRB 259617 B<br />
                    <strong>Registergericht:</strong> Amtsgericht Charlottenburg (Berlin)<br />
                    <strong>VAT-ID:</strong> DE452660211
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Management</h3>
                  <p>
                    <strong>Geschäftsführer:</strong> Nicholas Fendel
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Contact Information</h3>
                  <p>
                    <strong>Email:</strong> hello@trbe.ai<br />
                    <strong>Phone:</strong> +49 (0) 30 1234 5678<br />
                    <strong>Website:</strong> www.trbe.ai
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Liability for Contents</h3>
                  <p>
                    As service providers, we are liable for own contents of these websites according to Sec. 7, Para. 1 German Telemedia Act (TMG). However, according to Sec. 8 to 10 German Telemedia Act (TMG), service providers are not under obligation to permanently monitor submitted or stored information or to search for evidences that indicate illegal activities.
                  </p>
                  <p>
                    Legal obligations to removing information or to blocking the use of information remain unchallenged. In this case, liability is only possible at the time of knowledge about a specific violation of law. Illegal contents will be removed immediately at the time we get knowledge of them.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Liability for Links</h3>
                  <p>
                    Our offer includes links to external third party websites. We have no influence on the contents of those websites, therefore we cannot guarantee for those contents. Providers or administrators of linked websites are always responsible for their own contents.
                  </p>
                  <p>
                    The linked websites had been checked for possible violations of law at the time of the establishment of the link. Illegal contents were not detected at the time of the linking. A permanent monitoring of the contents of linked websites cannot be imposed without reasonable indications that there has been a violation of law. Illegal links will be removed immediately at the time we get knowledge of them.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Copyright</h3>
                  <p>
                    Contents and compilations published on these websites by the providers are subject to German copyright laws. Reproduction, editing, distribution as well as the use of any kind outside the scope of the copyright law require a written permission of the author or originator. Downloads and copies of these websites are permitted for private use only.
                  </p>
                  <p>
                    The commercial use of our contents without permission of the originator is prohibited.
                  </p>
                  <p>
                    Copyright laws of third parties are respected as long as the contents on these websites do not originate from the provider. Contributions of third parties on this site are indicated as such. However, if you notice any violations of copyright law, please inform us. Such contents will be removed immediately.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Imprint;
